import { Checkbox, Form, Input } from 'antd';
import type { FC } from 'react';

import { Option, Select } from 'app/components/fields/Select';
import { ChannelManager } from 'app/typings/channelManagers';
import type { NewHotel } from 'app/typings/hotels/NewHotel/NewHotel';
import { RateMode } from 'app/typings/rateModes';
import { ChannelManagerDataSource } from 'app/utils/channelManagers/channelManagers';
import { getDerbysoftSuppliersDataSource } from 'app/utils/channelManagers/derbysoft';
import { getRateModesDataSource } from 'app/utils/channelManagers/rateModes';

import './ChannelManagerSelect.scss';

export const ChannelManagerSelect: FC<Props> = ({ onValuesChange, values }) => (
  <div className="channel-manager-block">
    <Form.Item
      name="channelManager"
      label="Channel manager"
      rules={[{ required: true }]}
    >
      <Select
        showSearch
        defaultValue={ChannelManager.NONE}
        onSelect={(cm) => {
          onValuesChange(null, {
            ...values,
            channelManager: cm,
          });
        }}
      >
        {ChannelManagerDataSource.map((data) => (
          <Option key={data.id} value={data.id}>
            {data.name}
          </Option>
        ))}
      </Select>
    </Form.Item>
    {values?.channelManager &&
      values.channelManager !== ChannelManager.NONE && (
        <Form.Item
          name="rateMode"
          label="Connected rates"
          rules={[{ required: true }]}
          initialValue={RateMode.SINGLE_RATE}
        >
          <Select
            showSearch
            onSelect={(rm) => {
              onValuesChange(null, {
                ...values,
                rateMode: rm,
              });
            }}
          >
            {getRateModesDataSource(false).map((data) => (
              <Option key={data.id} value={data.id} disabled={data.disabled}>
                {data.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}
    <Form.Item
      label="Includes breakfast (BAR BB)"
      name="connectedBarBb"
      valuePropName="checked"
    >
      <Checkbox
        onChange={(e) => {
          onValuesChange(null, {
            ...values,
            connectedBarBb: e.target.checked,
          });
        }}
      />
    </Form.Item>
    {values?.channelManager &&
      values.channelManager === ChannelManager.MEWS && (
        <Form.Item
          name="channelManagerCredentials"
          label="Channel Manager Credentials"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
      )}
    {values?.channelManager &&
      values.channelManager === ChannelManager.DERBYSOFT && (
        <>
          <Form.Item
            name="supplierId"
            label="Supplier ID"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              onSelect={(supplierId) => {
                onValuesChange(null, {
                  ...values,
                  supplierId,
                });
              }}
            >
              {getDerbysoftSuppliersDataSource().map((data) => (
                <Option key={data.id} value={data.id}>
                  {data.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </>
      )}
  </div>
);

type Props = {
  onValuesChange: (_: unknown, values: Partial<NewHotel>) => void;
  values?: Partial<NewHotel>;
};
